import { Component, Input } from '@angular/core';
import { TranslatePipe } from '../../../../core/pipes/translate.pipe';
import { Expert } from '../expert-card/expert-card';

@Component({
  selector: 'app-expert-profile-properties',
  imports: [TranslatePipe],
  templateUrl: './expert-profile-properties.html',
  styleUrl: './expert-profile-properties.scss',
})
export class ExpertProfilePropertiesComponent {
  @Input() expert: Expert | null = null;
}
